import React from "react";
import { Backdrop, CircularProgress } from "@mui/material";

const BackdropLoader = () => {
  return (
    <Backdrop open style={{ zIndex: 10000 }}>
      <CircularProgress color="primary" />
    </Backdrop>
  );
};

export default BackdropLoader;
